<template>
    <div class="c-product-data-standard">
        <b-row class="mt-3">
            <b-col lg="4">
                        <InputCurrency
                                :label="Core.Definition.getDefinition('Prix régulier')"
                                v-model="dataValue.regularPrice"></InputCurrency>
                        <InputCheckbox
                                :label="Core.Definition.getDefinition('Taxable')"
                                v-model="dataValue.isTaxable"></InputCheckbox>
            </b-col>
            <b-col lg="4">
                        <InputCheckbox
                                :label="Core.Definition.getDefinition('Gestion des stocks')"
                                v-model="dataValue.stockManagement"></InputCheckbox>
                        <InputNumber
                                v-if="dataValue.stockManagement"
                                :label="Core.Definition.getDefinition('Quantité en stock')"
                                v-model="dataValue.stockQuantity"></InputNumber>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import Alert from './Alert'
    import InputSelect from './InputSelect'
    import InputDate from './InputDate'
    import InputText from './InputText'
    import InputCurrency from './InputCurrency'
    import InputCC from './InputCC'
    import InputNumber from "./InputNumber"
    import InputCheckbox from "./InputCheckbox";
    export default {
        name: 'ProductDataStandard',
        components: {
            InputCheckbox,
            InputCurrency,
            InputSelect,
            InputText,
            InputDate,
            InputCC,
            Alert,
            InputNumber
        },
        props: {
            id: {
                type: String,
                default: ''
            },
            value: {
                type: Object,
                default: function () {}
            },
            form: {
                type: Object,
                default: function () {
                    return {
                    }
                }
            },
            fieldRefs: {
                type: Array,
                default: function () {
                    return []
                }
            }
        },
        watch: {
            value(val) {
                this.dataValue = val
            },
            dataValue: {
                handler(val) {
                    this.$emit('input', val)
                },
                deep: true
            }
        },
        mounted() {
            this.dataValue = Core.Array.newObject(this.value)
        },
        data: () => {
            return {
                Core: window.Core,
                dataValue: {
                    regularPrice: '0',
                    expirationPeriod: Core.Value.selectValue(Core.Product.periodMonth, Core.Product.periodOptions()),
                    expirationPeriodLength: '0',
                    bookingLimitManagement: false,
                    bookingLimit: '0',
                    periodLength: '0',
                    period: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                    periodPaymentInterval: Core.Select.select(Core.Product.periodIntervalOne, Core.Product.periodIntervalOptions()),
                    periodPayment: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                    periodPaymentLength: '0',
                    attributes: [],
                    variations: [],
                    isTaxable: true,
                    stockManagement: false,
                    stockQuantity: 0,
                    quantity: 0,
                    ticketIsEnabled: false,
                    ticketTemplate: null
                }
            }
        },
        methods: {
        }
    }
</script>
